import {Component, Input, OnInit} from '@angular/core';
import {environment} from 'src/environments/environment';
import Tag from '../../../smoothr-web-app-core/models/Tag';

@Component({
	selector: 'app-tag',
	templateUrl: './tag.component.html',
	styleUrls: ['tag.component.scss'],
	standalone: false
})
export class TagComponent implements OnInit {
	@Input() tags: Tag[];
	@Input() iconSize: {width: number; height: number} = {width: 24, height: 24};
	environment = environment;

	constructor() {}

	ngOnInit() {}
}
